module.exports = __webpack_require__.p + "fe174ac16c80b11a3cacbfa1e0504c2a.jpg";